import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const AntiguaBarbuda: Country = {
    identifier: "AntiguaBarbuda",
    name: "Antigua and Barbuda",
    countryCode: "AG",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: true,
    flag: "🇦🇬",
    svgPath: "m 301.68975,414.7024 -0.09,0.116 -0.313,-0.047 -0.063,-0.145 -0.014,-0.102 0.196,-0.207 0.221,0.088 0.085,0.098 0.063,0.02 -10e-4,0.083 -0.024,0.061 -0.06,0.035 z m -0.087,-1.572 -0.042,0.077 -0.229,-0.139 -0.07,-0.261 0.007,-0.055 0.039,-0.029 0.091,0.05 0.121,0.019 0.077,0.085 0.006,0.253 z",
}
